<div class="row full-height" *ngIf="beneficiary">
  <div class="col-12 col-lg-3">
    <app-beneficiary-summary [beneficiary]="beneficiary" page="beneficiaryFolderPage"></app-beneficiary-summary>
  </div>
  <div class="col-12 col-lg-9 border-start bg-white px-0">
    <ul class="nav-tabs nav-fill" ngbNav #nav="ngbNav" (navChange)="onNavChange($event)" [activeId]="activeTabId">
      <li [ngbNavItem]="'interviews'">
        <a ngbNavLink><h5 class="text-secondary" id="interviewsTitle">Contacts</h5></a>
      </li>
      <li [ngbNavItem]="'contracts'" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE']">
        <a ngbNavLink><h5 class="text-secondary" id="contractsTitle">Contrats</h5></a>
      </li>
      <li [ngbNavItem]="'stages'" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE']">
        <a ngbNavLink><h5 class="text-secondary" id="stagesTitle">Étapes</h5></a>
      </li>
      <li [ngbNavItem]="'fse'" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION', 'DIRECTION+', 'TERRITORY']">
        <a ngbNavLink><h5 class="text-secondary" id="fseTitle">Indicateurs / FSE</h5></a>
      </li>
      <li [ngbNavItem]="'assessment'" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION', 'DIRECTION+', 'TERRITORY']">
        <a ngbNavLink><h5 class="text-secondary" id="assessmentsTitle">Diagnostics</h5></a>
      </li>
    </ul>
    <router-outlet></router-outlet>
  </div>
</div>
